import React, { useEffect, useState } from 'react';
import { Card } from './card';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { useProductDetailStore } from '../store';
import { useCountry } from '@/hooks/use-country';

interface IProps {
  className?: string;
}

const ChemicalIdentifiersDisplay = [
  'MDL Number',
  'Molecular Formula',
  'Molecular Weight (g/mol)',
  'InChI Key',
  'Synonym',
  'PubChem CID',
  'ChEBI',
  'IUPAC Name',
  'SMILES',
  'CAS',
].map((item) => item.toLocaleUpperCase());

export const ProductAttributes = (props: IProps) => {
  const { isCN, isKR } = useCountry();
  const { t } = useLang(NAMESPACE.pdp);
  const { productDetail } = useProductDetailStore();
  const { properties, productBaseInfo } = productDetail ?? {};
  const [identifiersOptions, setIdentifiersOptions] = useState([]);
  const [specificationsOptions, setSpecificationsOptions] = useState([]);
  const [filters, setFilters] = useState([]);
  const showSpecifications = productBaseInfo.localProduct !== true || isCN;

  useEffect(() => {
    let identifiers = properties.CHEMICAL_IDENTIFIERS ?? [];
    if (productBaseInfo.localProduct === true && isKR) {
      identifiers = identifiers.filter((e) => e?.displayName === 'CAS');
    }

    const identifiersNames = identifiers?.map((item) => item?.displayName?.toUpperCase());
    const filters = ChemicalIdentifiersDisplay.filter((item) => !identifiersNames?.includes(item));
    setFilters(filters);
    setIdentifiersOptions(identifiers);
  }, [productBaseInfo, properties]);

  useEffect(() => {
    const specifications = properties.SPECIFICATIONS ?? [];

    const filteredSpecifications = specifications?.filter((e) => {
      const displayName = e?.displayName?.toUpperCase();
      if (isCN) {
        return !filters?.includes(displayName) && !displayName?.includes('HAZARD');
      } else {
        return !displayName?.includes('HAZARD');
      }
    });
    setSpecificationsOptions(filteredSpecifications);

    if (isCN) {
      const needShowIdentifiers = specifications?.filter((e) => {
        const displayName = e?.displayName?.toUpperCase();
        return filters?.includes(displayName);
      });
      setIdentifiersOptions((pre) => [...pre, ...needShowIdentifiers]);
    }
  }, [properties.SPECIFICATIONS, filters]);

  return (
    <div
      className={`grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 w-full gap-x-[60px] mt-7 product-attributes ${
        props.className ?? ''
      }`}
    >
      <Card className="col-span-1 h-fit" title={t('chemical.identifiers')} options={identifiersOptions} limit={6} />
      {showSpecifications && (
        <Card
          className="col-span-1 h-fit sm:mt-8 md:mt-8"
          title={t('specifications')}
          options={specificationsOptions}
        />
      )}
    </div>
  );
};
